import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { IBulkTransfer } from '../../../types/transfer';
import { RootState } from '../..';

interface IGetBulkTransfersResponse {
  status?: boolean;
  message?: string;
  data?: IBulkTransfer[];
  meta?: {
    total?: number;
    perPage?: number;
    totalPages?: number;
    page?: number;
  };
  errors?: IApiResponseError[];
}

const initialState: IApiState<IGetBulkTransfersResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getBulkTransfersAsync = createAsyncThunk(
  'bulkTransfers',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId = localStorage.getItem('businessId');

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.get(
        `/transfers/customers/${businessId}/bulk`,
        config
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<IApiResponseError>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const bulkTransfersGetSlice = createSlice({
  name: 'bulkTransfers/get',
  initialState,
  reducers: {
    resetGetBulkTransfers: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBulkTransfersAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getBulkTransfersAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetBulkTransfersResponse;
      })
      .addCase(getBulkTransfersAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetBulkTransfersResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetGetBulkTransfers } = bulkTransfersGetSlice.actions;

export default bulkTransfersGetSlice.reducer;
